export default __webpack_public_path__ + "static/media/phone.aca28bd9.svg";